import React from 'react';
import {connect} from 'react-redux';
import {FormattedMessage, injectIntl} from "react-intl";

import {UI_POPUP_TYPES} from "../../../reducers/R_Popups";
import {setUiPopupState} from "../../../actions/A_Popups";


class AccountTwoFaLabel extends React.Component {

  render() {

    const {formValues, setUiPopupState, accountPageInfo} = this.props;
    const {isFabricator, canEditFields, isEmployee} = this.props.accountPageInfo;

    if (!canEditFields || !isFabricator || isEmployee) {
      return null
    }

    if (formValues.verifiedPhoneNumber) {
      return (
        <span className="mb-025 pl-05 color-green bold">
          <FormattedMessage id="twoFA.verified"/>
        </span>
      )
    }

    const openTwoFAModal = () => {
      console.log("accountPageInfo", accountPageInfo);
      setUiPopupState({
        headerTextId: "twoFA.title",
        className: "",
        style: {maxWidth: "540px", maxHeight: "320px"},
        opened: true,
        type: UI_POPUP_TYPES.fabricatorTwoFA,
        context: {
          fabricatorId: accountPageInfo.entityId
        },
        buttons: [],
      });
    }

    return (
      <span className="mb-025 pl-075 link link--blue bold" onClick={openTwoFAModal}>
        Verification required *
      </span>
    )
  }

}

const mapStateToProps = (store) => {
  return {
    accountPageInfo: store.accountState.accountPageInfo,
    formValues: (store.form && store.form.newEntity && store.form.newEntity.values) || {}
  };
};

const mapDispatchToProps = {
  setUiPopupState,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AccountTwoFaLabel)
)

